














































































import Vue from "vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { Line } from "../models/Line";

export default Vue.extend({
  mixins: [pagination, dialog, permission],
  data() {
    const shops: Line[] = [];

    return {
      shops
    };
  },
  computed: {
    hasCreateLinePermission() {
      return (this as any).hasPermission(PermissionName.LINE_CREATE);
    }
  },
  watch: {
    async "$route.query"() {
      await this.getShopsLine();
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getShopsLine()]);
  },
  methods: {
    async getShopsLine() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const { data, meta } = await (this as any).$dep.lineUseCase.getLine(
          form
        );

        this.shops = data;

        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToLineCreatePage() {
      this.$router.push({ name: "LineCreatePage" });
    },
    goToLineUpdatePage(id: any) {
      this.$router.push({ name: "LineUpdatePage", params: { id } });
    },
    async syncProductDialog(line: Line) {
      const isComfirmed = await (this as any).alertConfirm(
        "Sync สินค้า",
        `คุณต้องการที่จะ Sync สินค้าร้าน ${line.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.syncProduct(line.shopId!);
      }
    },
    async syncProduct(id: number) {
      try {
        await (this as any).$dep.lineUseCase.syncProductByShopId(id);
        (this as any).alertSuccess("Success", "เริ่มการ Sync สินค้าแล้ว");
        this.getShopsLine();
      } catch (error) {
        console.log(error);
      }
    },
    async syncStockDialog(line: Line) {
      const isComfirmed = await (this as any).alertConfirm(
        "Sync Stock",
        `คุณต้องการที่จะ Sync Stock ร้าน ${line.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.syncStock(line.shopId!);
      }
    },
    async syncStock(id: number) {
      try {
        await (this as any).$dep.lineUseCase.syncStockByShopId(id);
        (this as any).alertSuccess("Success", "เริ่มการ Sync Stock แล้ว");
        this.getShopsLine();
      } catch (error) {
        console.log(error);
      }
    },
    async deleteShopDialog(line: Line) {
      const isComfirmed = await (this as any).alertConfirm(
        "ลบร้าน",
        `คุณต้องการที่จะลบร้าน ${line.shopName} ใช่ไหม?`
      );

      if (isComfirmed) {
        this.deleteShop(line.id!);
      }
    },
    async deleteShop(id: number) {
      try {
        await (this as any).$dep.lineUseCase.deleteLine(id);
        (this as any).alertSuccess("Success", "ลบร้านสำเร็จ");
        this.getShopsLine();
      } catch (error) {
        console.log(error);
      }
    }
  }
});
